export default __webpack_public_path__ + "static/media/Group 46.59b5a4a9.svg";